<script setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
onMounted(() => {
  if (route.query.hold !== '1') setTimeout(() => router.replace('/login'), 1450);
});
</script>

<template>
  <section class="splash-screen">
    <div class="splash-brand">
      <img src="/assets/u1card-logo.png" alt="U1Card" />
      <strong>U1card</strong>
    </div>
  </section>
</template>

<style scoped>
.splash-screen { position: relative; width: min(100%,420px); min-height: 100dvh; overflow: hidden; background: radial-gradient(circle at 50% 42%,#715fff 0,#5a45fe 38%,#4833e9 100%); }
.splash-brand { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; transform: translateY(-8px); }
.splash-brand img { width: 126px; height: 126px; object-fit: contain; filter: brightness(1.08) drop-shadow(0 12px 30px rgba(29,16,132,.3)); }
.splash-brand strong { margin-top: 4px; font-size: 30px; font-weight: 760; letter-spacing: -.04em; }
@media (min-width:600px) { .splash-screen { min-height:820px; height:min(calc(100vh - 48px),900px); margin:24px 0; border-radius:28px; box-shadow:0 28px 80px rgba(0,0,0,.55); } }
</style>
